import React, { Component } from 'react';
import { Button, Card, Col, Form, Input, Row, Divider } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
class NewBotFormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: true };
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Form>
                <Card bordered={false} style={{ marginBottom: 15 }}>
                    <Row gutter={24}>
                        <Col md={24}>
                            <Form.Item label="Name" required={true}>
                                {getFieldDecorator('name', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(<Input size="large" />)}
                            </Form.Item>
                        </Col>

                        <Divider orientation="left">API Keys</Divider>

                        <Col md={12}>
                            <Form.Item label="Api Key" required={true}>
                                {getFieldDecorator('api_key', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(<Input.Password size="large" />)}
                            </Form.Item>
                        </Col>

                        <Col md={12}>
                            <Form.Item label="Api Secret" required={true}>
                                {getFieldDecorator('api_secret', {
                                    rules: [{ required: true, message: 'Field is required' }]
                                })(<Input.Password size="large" />)}
                            </Form.Item>
                        </Col>

                        <Button
                            size="large"
                            loading={this.props.busy}
                            onClick={this.handleSubmit.bind(this)}
                            style={{ width: '100%' }}
                            type="primary"
                        >
                            Create
                        </Button>
                    </Row>
                </Card>
            </Form>
        );
    }
}

export const OdysseyBotForm = Form.create({})(NewBotFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bots/New/OdysseyForm.js